
import ProfileContainer from '../components/home/profilecontainer'
import React, { useState, useEffect } from "react";

import Header from "../components/home/header";
import SidebarComponent from './SidebarComponent';
import { GoogleAd } from '../components/ads/GoogleAd';
import { useScreen } from '../contexts/screen.provider';
import Profile from '../components/profile/profile';


function Profilepage() {
  const [displaySidebar, setDisplaySidebar] = useState(false);
  const { isMobile, isDesktop } = useScreen()

  function changeSidebarDisplay() {
    setDisplaySidebar((prev) => !prev);
  }



  return (
    <div className="w-full overflow-y-auto  h-screen custom-scrollbar  bg-white dark:bg-[#202020] flex flex-col ">
      <Header
        isAdsVisible={true}
        sidebarDisplay={displaySidebar}
        changeSidebarDisplay={changeSidebarDisplay} />
      <main className="flex mt-[6vh] md:mt-[7vh] tablet:mt-[10vh] gap-2  tablet:px-4 px-4    flex-col items-center tablet:items-start   tablet:flex-row flex-grow relative">
        <SidebarComponent setSidebarDisplay={setDisplaySidebar} sidebarDisplay={displaySidebar} />
        {!isMobile && <GoogleAd />}
        <Profile />
        {
          isDesktop
            ?
            <GoogleAd />
            :
            <div className="h-full w-full ">
              <GoogleAd />
            </div>
        }
      </main>
    </div>

  )
}

export default Profilepage
